import { Card, makeStyles, Paper, Typography } from "@material-ui/core";
import ModuleDisplayInfo from "components/legacy/utils/module-display-info";
import _ from "lodash";
import { ResourceCustomTheme } from "styles/config";

const useStyles = makeStyles((theme: ResourceCustomTheme) => ({
  root: { width: 240, backgroundColor: "white" },
  moduleCard: {
    backgroundColor: theme.colors.MidnightBlue(100),
    padding: theme.spacing(1),
    margin: theme.spacing(1),
  },
  header: {
    marginTop: theme.spacing(1),
  },
  label: {},
}));

type ContentTemplatePreviewProps = {
  modules: {
    id: string;
    type: string;
  }[];
};

function ContentTemplatePreview({ modules }: ContentTemplatePreviewProps) {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={2}>
      <Typography variant="subtitle2" className={classes.header}>
        Content Template Preview
      </Typography>
      {_.map(_.slice(modules, 0, 5), ({ id, type: moduleType }) => (
        <Card key={id} className={classes.moduleCard} elevation={1}>
          <Typography variant="body1" className={classes.label}>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {ModuleDisplayInfo[moduleType]?.header}
          </Typography>
        </Card>
      ))}
      {modules.length > 5 && (
        <Card key="overflow" className={classes.moduleCard} elevation={1}>
          <Typography variant="body1" className={classes.label}>
            + {modules.length - 5} more
          </Typography>
        </Card>
      )}
    </Paper>
  );
}

export default ContentTemplatePreview;
